import {
  GET_ONE_PRODUCT,
  GET_ALL_PRODUCTS,
  GET_ADD_TO_CART,
  GET_ORDER_CART,
  GET_ADD_COUNTER_CART,
  GET_MINUS_COUNTER_CART,
  GET_DELETE_CART,
  SET_ORDER_BRANCH_SAVE,
  GET_COME_TO_PAY,
  GET_ORDER_PAYMENT,
  GET_CUSTOMER_INFORMATION,
} from "../../resources/js/helpers/requests";
import { checkoutError, isPaymentConfirmed, confirmedReceipt, checkoutReview, sameCheckoutReview, checkoutReviewChanged } from "../../resources/js/helpers/checkout";

const customerRequests = new WeakMap();

export default {
  state: {
    perPage: "",
    customerInformation: {},
    customerRefreshPending: false,
    customerRefreshError: false,
    openProduct: {},
    products: [],
    max_price: 0,
    customerCart: {},
    order_id: null,
    searchText: "",
    filterParametrs: {},
    checkedCategory: null,
    succedOrder: null,
    checkoutPendingOrder: null,
    checkoutSaveUncertain: false,
    checkoutBusy: false,
    checkoutDraft: null,
  },
  mutations: {
    addPerPage(state, page) {
      state.perPage = page;
    },
    setChangeCustomerInformation(state, customer) {
      state.customerInformation = customer;
    },
    setCustomerRefreshPending(state, pending) {
      state.customerRefreshPending = pending;
    },
    setCustomerRefreshError(state, failed) {
      state.customerRefreshError = failed;
    },
    setIsOpenProductInfo(state, product) {
      state.openProduct = product;
    },
    setAddProducts(state, products) {
      state.products = products;
    },
    setAddMaxPrice(state, price) {
      state.max_price = price;
    },
    setAddProductToCart(state, product) {
      state.customerCart = product;
    },
    setOrderId(state, id) {
      state.order_id = id;
    },
    setChangeSearchText(state, text) {
      state.searchText = text;
    },
    setFilterParametrs(state, data) {
      state.filterParametrs = data;
    },
    deleteFilterCategoryParametr(state) {
      state.filterParametrs = delete state.filterParametrs.category_ids;
    },
    setSaveSuccedOrder(state, data) {
      state.succedOrder = data;
    },
    setCheckoutPendingOrder(state, order) {
      state.checkoutPendingOrder = order;
    },
    setCheckoutSaveUncertain(state, uncertain) {
      state.checkoutSaveUncertain = uncertain;
    },
    setCheckoutBusy(state, busy) {
      state.checkoutBusy = busy;
    },
    setCheckoutDraft(state, draft) {
      state.checkoutDraft = draft;
    },
    setFilterPriceParametrs(state, data) {
      state.filterParametrs = {
        ...state.filterParametrs,
        price_from: data.price_from,
        price_to: data.price_to,
      };
    },
    deleteFilterParametr(state) {
      state.filterParametrs = {};
    },
    setCheckedCategory(state, data) {
      state.checkedCategory = data;
    },
  },
  actions: {
    async getCustomerInfo({ commit, state }, id) {
      const active = customerRequests.get(state);
      if (active && String(active.id) === String(id)) return active.promise;
      commit("setCustomerRefreshPending", true);
      commit("setCustomerRefreshError", false);
      const request = { id, promise: null };
      customerRequests.set(state, request);
      request.promise = (async () => {
        try {
          const result = await GET_CUSTOMER_INFORMATION(id);
          const customer = result?.data;
          if (!customer || Number(customer.id) !== Number(id) ||
              customer.bonuses === null || customer.bonuses === "" ||
              !["number", "string"].includes(typeof customer.bonuses) || !Number.isFinite(Number(customer.bonuses))) {
            throw new Error("Invalid customer balance response");
          }
          if (customerRequests.get(state) === request) commit("setChangeCustomerInformation", customer);
          return customer;
        } catch (error) {
          if (customerRequests.get(state) === request) commit("setCustomerRefreshError", true);
          throw error;
        } finally {
          if (customerRequests.get(state) === request) {
            customerRequests.delete(state);
            commit("setCustomerRefreshPending", false);
          }
        }
      })();
      return request.promise;
    },
    async getOneProduct({ commit }, id) {
      let result = await GET_ONE_PRODUCT(id);
      commit("setIsOpenProductInfo", result.data);
      return result;
    },
    async getAllProducts({ commit }, id) {
      let result = await GET_ALL_PRODUCTS(id);
      commit("setAddProducts", result?.data);
    },
    async addProductToCart({ commit }, body) {
      let result = await GET_ADD_TO_CART(body);
      commit("setAddProductToCart", result.data);
      return result;
    },
    async getCartProducts({ commit }, id) {
      let result = await GET_ORDER_CART(id);
      if (!Array.isArray(result?.data)) throw checkoutError("Не вдалося оновити кошик.");
      commit("setAddProductToCart", result.data);
      return result.data;
    },
    async getOneMoreProduct({ commit }, data) {
      let result = await GET_ADD_COUNTER_CART(data);
      commit("setAddProductToCart", result.data);
    },
    async getMinusProduct({ commit }, data) {
      let result = await GET_MINUS_COUNTER_CART(data);
      commit("setAddProductToCart", result.data);
    },
    async deleteProductFromCart({ commit }, data) {
      let result = await GET_DELETE_CART(data);
      commit("setAddProductToCart", result.data);
    },

    async setSaveOrder({ commit, state, dispatch }, data) {
      const review = typeof data === "object" ? data.review : null;
      if (typeof data === "object") data = data.data;
      if (state.checkoutBusy) throw checkoutError("Оформлення вже триває. Зачекайте на результат.");
      commit("setSaveSuccedOrder", null);
      if (state.checkoutSaveUncertain) {
        throw checkoutError("Не вдалося перевірити, чи створено замовлення. Не оформлюйте його повторно; зверніться до представника для перевірки.");
      }
      commit("setCheckoutBusy", true);
      const customerId = state.customerInformation.id;
      const finish = async (order, result) => {
        if (!isPaymentConfirmed(result, order.id)) throw checkoutError("Сервер не підтвердив оплату цього замовлення. Спробуйте перевірити результат ще раз.");
        commit("setSaveSuccedOrder", { ...order, ...result, receipt: confirmedReceipt(result) });
        commit("setCheckoutPendingOrder", null);
        commit("setCheckoutDraft", null);
        commit("setAddProductToCart", []);
        // Refresh failures must not turn an already committed purchase into a payment failure.
        await Promise.allSettled([
          dispatch("getCustomerInfo", customerId),
          dispatch("getCartProducts", customerId),
        ]);
        return result;
      };
      const refreshBeforePayment = async (items) => {
        let customer;
        try {
          customer = await dispatch("getCustomerInfo", customerId);
        } catch (error) {
          if (error.status === 401 || error.status === 403) throw error;
          throw checkoutError("Не вдалося оновити баланс. Перевірте з’єднання та спробуйте ще раз; оплату не розпочато.");
        }
        const total = (Array.isArray(items) ? items : []).reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0);
        if (Number(customer.bonuses) < total) throw checkoutError("Недостатньо балів для покупки. Баланс оновлено; поповніть його або змініть кошик.");
      };
      try {
        let order = state.checkoutPendingOrder;
        if (order) {
          const payment = await GET_ORDER_PAYMENT(order.id);
          if (Number(payment.order_id) !== Number(order.id)) throw checkoutError("Не вдалося перевірити це замовлення.");
          if (payment.payment_status === "paid") return await finish(order, { ...payment, status: "ok" });
          if (payment.payment_status !== "pending") throw checkoutError("Це замовлення вже скасоване або повернене. Зверніться до представника.");
          await refreshBeforePayment(order.items || state.customerCart);
          if (review && !sameCheckoutReview(review, checkoutReview(state.customerCart, state.customerInformation, order))) throw checkoutReviewChanged();
        } else {
          if (review) await dispatch("getCartProducts", customerId);
          await refreshBeforePayment(state.customerCart);
          if (review && !sameCheckoutReview(review, checkoutReview(state.customerCart, state.customerInformation))) throw checkoutReviewChanged();
          try {
            const saved = await SET_ORDER_BRANCH_SAVE(data);
            order = saved?.data;
            if (!Number.isSafeInteger(Number(order?.id)) || Number(order.id) <= 0) {
              throw checkoutError("Сервер не повернув номер замовлення.");
            }
            commit("setCheckoutPendingOrder", order);
          } catch (error) {
            // A lost/invalid response or 5xx may follow a committed save. Never blindly save again.
            if (!error.status || error.status >= 500) {
              commit("setCheckoutSaveUncertain", true);
              throw checkoutError("Не вдалося перевірити, чи створено замовлення. Не оформлюйте його повторно; зверніться до представника для перевірки.");
            }
            throw error;
          }
          if (review && !sameCheckoutReview(review, checkoutReview(state.customerCart, state.customerInformation, order))) throw checkoutReviewChanged();
        }
        try {
          const result = await GET_COME_TO_PAY(JSON.stringify({ order_id: order.id }));
          return await finish(order, result);
        } catch (error) {
          // The payment might have committed before the response was lost.
          try {
            const payment = await GET_ORDER_PAYMENT(order.id);
            if (payment.payment_status === "paid" && Number(payment.order_id) === Number(order.id)) {
              return await finish(order, { ...payment, status: "ok" });
            }
          } catch (verificationError) {
            // Preserve the known order and retry verification, never a new save.
          }
          throw error;
        }
      } finally {
        commit("setCheckoutBusy", false);
      }
    },
  },
  getters: {
    customerRefreshPending: (state) => state.customerRefreshPending,
    customerRefreshError: (state) => state.customerRefreshError,
    perPageName: (state) => {
      return state.perPage;
    },
    customerInfo: (state) => {
      return state.customerInformation;
    },
    openedProduct: (state) => {
      return state.openProduct;
    },
    getProducts: (state) => {
      return state.products;
    },
    getMaxPrice: (state) => {
      return state.max_price;
    },
    getCustomerCart: (state) => {
      return state.customerCart;
    },
    getOrderId: (state) => {
      return state.order_id;
    },
    getSearchText: (state) => {
      return state.searchText;
    },
    getFilterParametrs: (state) => {
      return state.filterParametrs;
    },
    getCheckedCategory: (state) => {
      return state.checkedCategory;
    },
    getSuccedOrder: (state) => {
      return state.succedOrder;
    },
    checkoutLocked: (state) => Boolean(state.checkoutPendingOrder || state.checkoutSaveUncertain),
    checkoutPendingOrder: (state) => state.checkoutPendingOrder,
    checkoutSaveUncertain: (state) => state.checkoutSaveUncertain,
    checkoutDraft: (state) => state.checkoutDraft,
  },
};
